/// <reference path="../../_ext/Bases/DialogBase.ts" />

namespace TabAurous.Inventory {
    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    @Serenity.Decorators.maximizable()
    @Serenity.Decorators.responsive()
    export class SKUGenerationDialog extends _Ext.TransDialog<SKUGenerationRow, any> {
        protected getFormKey() { return SKUGenerationForm.formKey; }
        protected getIdProperty() { return SKUGenerationRow.idProperty; }
        protected getLocalTextPrefix() { return SKUGenerationRow.localTextPrefix; }
        protected getNameProperty() { return SKUGenerationRow.nameProperty; }
        protected getService() { return SKUGenerationService.baseUrl; }
        protected getDeletePermission() { return SKUGenerationRow.deletePermission; }
        protected getInsertPermission() { return SKUGenerationRow.insertPermission; }
        protected getUpdatePermission() { return SKUGenerationRow.updatePermission; }
        protected get_ExtDialogOptions(): ExtDialogOptions { return Q.deepClone(q.DefaultEntityDialogOptions); }

        public form = new SKUGenerationForm(this.idPrefix);
        public Closing: boolean;

        constructor() {
            super();
            //Make grid full width

            q.hideEditorLabel(this.form.Details);
            q.hideEditorLabel(this.form.PrintingDetails);
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initItemEditor(this, this.form.Details, Config);
            q.initItemEditor(this, this.form.PrintingDetails, Config);
            q.setTextRightAlign(this.form.NoofSKU);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Markup);
            //q.hideCaption(this.form.Posted);
            q.SetCategorySixColumn(this.form.TransDate);
            q.SetCategoryFullWidth(this.form.Details);

            this.form.GenerateSKU.onClick = (e) => {
                this.GenSKU(e);
            };

            this.form.NoofSKU.changeSelect2(e => {

               
            });
        }

        private GenSKU(e: any) {
            if (this.form.NoofSKU.value > 0) {
                var selectedrow = this.form.Details.currentrow;
                var row = this.form.Details._row;
                var markup = 1;
                if (this.form.Markup != null)
                    markup = (this.form.Markup.value / 100) + 1;

                if (selectedrow == undefined) {
                    Q.alert('No item selected');
                    this.form.NoofSKU.value = 0;
                    return;
                } else if (this.form.NoofSKU.value > this.form.Pieces.value) {
                    Q.alert('Invalid No of Bags Entered');
                    this.form.NoofSKU.value = 0;
                    return;
                } else {
                    var olditemslength = this.form.PrintingDetails.getItems().length;
                    if (olditemslength < this.form.Pieces.value) {
                        var returnvalues = this.form.Details.setData(selectedrow, selectedrow.AttributeId, this.form.NoofSKU.value, row, markup);
                        this.form.NoofSKU.value = 0;
                        this.setPrintingGrid(returnvalues);
                    }
                    else {
                        Q.alert('Invalid No of Bags Entered');
                        this.form.NoofSKU.value = 0;
                        return;
                    }

                }
            }
            else {
                q.Warning("Enter Workshop", "Please select workshop before proceeding");
                this.form.NoofSKU.value = 0;
                return;
            }
        }

        public setPrintingGrid(items:any[]) {
            this.form.PrintingDetails.setItems([]); 
            this.form.PrintingDetails.setData(items);
        }

        public setStockItemGrid(items: any[]) {
            var lineno = this.form.LineNoSelected.value;
            var productid = this.form.ProductIdSelected.value;
            var attributeid = this.form.AttributeIdSelected.value;
            var sku = this.form.SKUSelected.value;
            var newitems = this.form.PrintingDetails.getItems();
            this.form.Details.setNewData(lineno, productid, attributeid, sku, newitems);
        }

        protected validateBeforeSave() {
            super.validateBeforeSave();
            var items = this.form.Details.getItems();
            this.form.PrintingDetails = null;
            return true;
        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();
            //var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");
            //var oldDeleteClick = btnDelete.onClick;
            //btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };


            ////Edit Click Override
            //var btnEdit = Q.first(btns, x => x.cssClass == "edit-button");
            //var oldEditClick = btnEdit.onClick;
            //btnEdit.onClick = e => { this.confirmBeforeEdit(oldEditClick, e); };


            var postingpermission = Q.Authorization.hasPermission('Inventory:SKUGeneration:Posting');
            //Export PDF Button
            btns.push({
                title: 'Post',
                icon: 'las la-check-double',
                cssClass: 'approve-doc-button',
                onClick: () => {
                    var entity = this.entity;
                    entity.AutoPosting = true; delete entity.TransDate;
                 
                    SKUGenerationService.Update({ Entity: entity, EntityId: entity.TransId }, response => {
                        if (response.Error == null) {
                            this.dialogClose();
                            Serenity.SubDialogHelper.triggerDataChange(this);
                        }
                    }, { async: false })
                },
                visible: postingpermission

            });




            return btns;
        } 
    }
}